import { render, staticRenderFns } from "./CurriculumStepsField.vue?vue&type=template&id=4cf5f621&scoped=true&lang=pug"
import script from "./CurriculumStepsField.vue?vue&type=script&lang=js"
export * from "./CurriculumStepsField.vue?vue&type=script&lang=js"
import style0 from "./CurriculumStepsField.vue?vue&type=style&index=0&id=4cf5f621&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf5f621",
  null
  
)

export default component.exports